module.exports = __webpack_public_path__ + "static/assets/c2989d5318f83822c3d9cc3c6c398842.gif";